/**
 * WEEX Exchange Metadata
 *
 * Configuration, documentation links, and notes for the WEEX exchange.
 */

import { WEEX_WS_CHANNELS, WEEX_WS_TOPOLOGY } from './ws';

import type { ExchangeId, ExchangeMetadata } from '../../lib/types';

export const WEEX_METADATA: ExchangeMetadata = {
  id: 'weex' as ExchangeId,
  restDocs: ['https://api-spot.weex.com'],
  wsDocs: ['https://api-spot.weex.com'],
  wsTopology: WEEX_WS_TOPOLOGY,
  wsChannels: WEEX_WS_CHANNELS,
  notes: [
    'Uses WEEX v2 spot API. Symbols keep the legacy "_SPBL" suffix (e.g. BTCUSDT_SPBL).',
    'Depth endpoint rejects a `limit` query param with code 40015 — request depth without limit.',
    'Candles use a `period` param and always return ~300 candles; no startTime/endTime.',
    'WebSocket subscribes one channel per message and uses event-based ping/pong with a `time` field.',
    'Data-only / display integration: market data + symbol info only (no order placement).',
  ],
};
